import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Shared state for inline (in-canvas) editing in the v2 editor - text fields
 * (appInlineEdit) and image slots (appInlineMedia). Provided on
 * PreviewV2Component, so every canvas gets its own session and all the fields
 * inside it share it. Blocks never use it directly - the directives report
 * focus/commit here and preview-v2 forwards them as outputs.
 */
@Injectable()
export class InlineEditSessionV2 {
  private enabledSubject = new BehaviorSubject<boolean>(false);
  /** False in View mode and in Proof/Annotate - fields then render read-only. */
  enabled$ = this.enabledSubject.asObservable();

  private focusedSubject = new Subject<string>();
  /** Block id of a field that just got focus. */
  focused$ = this.focusedSubject.asObservable();

  private committedSubject = new Subject<string>();
  /** Block id of a field that lost focus with different content than it got
   *  focus with, or of an image slot that got a new image. */
  committed$ = this.committedSubject.asObservable();

  setEnabled(enabled: boolean): void {
    if (enabled !== this.enabledSubject.value) {
      this.enabledSubject.next(enabled);
    }
  }

  focus(blockId: string): void {
    this.focusedSubject.next(blockId);
  }

  commit(blockId: string): void {
    this.committedSubject.next(blockId);
  }
}
